var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"popup_content"},_vm._l((_vm.Items),function(item){return _c('item',{key:item.index,attrs:{"route":item.route,"text":item.text}})}))}
var staticRenderFns = []

export { render, staticRenderFns }